import type { WeeklySlot } from './types';

export const CALENDAR_HOUR_HEIGHT = 48;
export const CALENDAR_HEIGHT = 24 * CALENDAR_HOUR_HEIGHT;

export function minutesToTime(minute: number): string {
  return `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
}

export function calendarMinuteAt(clientY: number, top: number, height: number): number {
  return Math.max(0, Math.min(1439, Math.round(((clientY - top) / height) * 1440 / 5) * 5));
}

export function calendarSelection(weekday: number, anchor: number, current: number): WeeklySlot {
  const start = Math.min(anchor, current);
  // A click adds a one-hour window. Dragging selects both endpoints explicitly.
  const end = anchor === current ? Math.min(1439, start + 60) : Math.max(anchor, current);
  return { weekday, timeLocal: minutesToTime(start), endTimeLocal: minutesToTime(end) };
}
